import { TableLayoutChips } from 'common/components/Layouts/TableLayout/TableLayout.tsx';
import { useHasActiveProductsManagementFilters } from '@/activityLog/productsManagement/Filters/hooks/useHasActiveProductsManagmentFilters.ts';
import { useAtom } from 'jotai';
import {
  ProductsManagementFilters,
  productsManagementFiltersAtom,
} from 'atoms/filters/products-management-filters.ts';
import { useTranslation } from 'react-i18next';
import {
  createDateRangeChipsContent,
  createStatusChipContent,
} from '@/activityLog/common/Chips/chipsUtils.ts';
import { useResetAtom } from 'jotai/utils';
import { FiltersChips } from 'common/components/Filters/FiltersChips.tsx';

export const ProductsManagementChips = () => {
  const [filters, setFilters] = useAtom(productsManagementFiltersAtom);
  const resetFilters = useResetAtom(productsManagementFiltersAtom);

  const hasChips = useHasActiveProductsManagementFilters(filters);

  const { t } = useTranslation();

  const createValuesForChips = (filters: ProductsManagementFilters) => {
    const { status } = filters;
    const chipsValues: Partial<Record<'status' | 'uploadDate', string>> = {};
    if (status !== '') {
      chipsValues.status = createStatusChipContent({ status, t });
    }
    const uploadDateChipsContent = createDateRangeChipsContent({
      ...filters,
      t,
    });
    if (uploadDateChipsContent) {
      chipsValues.uploadDate = uploadDateChipsContent;
    }
    return chipsValues;
  };

  const filtersChips = createValuesForChips(filters);

  const onFilterClear = (filterName: string) => {
    if (filterName === 'uploadDate') {
      setFilters((currentFilters) => ({
        ...currentFilters,
        uploadDateFrom: null,
        uploadDateTo: null,
      }));
    } else {
      setFilters((currentFilters) => ({ ...currentFilters, [filterName]: '' }));
    }
  };

  return (
    <TableLayoutChips hide={!hasChips}>
      <FiltersChips
        filters={filtersChips}
        onFilterClear={onFilterClear}
        onFiltersClear={resetFilters}
      />
    </TableLayoutChips>
  );
};
